module.exports = __webpack_public_path__ + "img/fat-free-peach-cobbler.d72e3f76.jpg";